// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__LBAck","title":"tabs_title__A3ttr","yellow":"tabs_yellow__CqrZ2","red":"tabs_red__Sx0NN"};